<script lang="ts">
  import type { BrandImage } from './types'
  import { isLightColor } from './utils'

  export let image: BrandImage;
  export let cardTitle: string | undefined = undefined;
  export let backgroundHex: string = '#000000';

  // Dynamic drop shadow based on background brightness
  $: dropShadow = isLightColor(backgroundHex)
    ? 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3)) drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))'
    : 'drop-shadow(0 2px 4px rgba(255, 255, 255, 0.2)) drop-shadow(0 4px 8px rgba(255, 255, 255, 0.1))';

  $: textShadow = isLightColor(backgroundHex)
    ? '0 2px 4px rgba(0, 0, 0, 0.3)'
    : '0 2px 4px rgba(255, 255, 255, 0.2)';
</script>

<div class="brand-header">
  <div class="brand-logo">
    <img class="image-no-transparent" src={image.url} alt={image.alternativeText || 'Brand logo'} style="filter: {dropShadow};" />
  </div>
  {#if cardTitle}
    <span class="brand-title" style="text-shadow: {textShadow};">{cardTitle}</span>
  {/if}
</div>

<style>
  .brand-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .brand-logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand-logo img {
    height: 36px;
    width: auto;
    object-fit: contain;
  }

  .brand-title {
    font-size: 20px;
    font-weight: 700;
    color: white;
  }

  /* Short AND narrow containers (height 0-200px, width < 800px) */
  @container (max-height: 200px) and (max-width: 799px) {
    .brand-logo img {
      height: 28px;
    }

    .brand-title {
      font-size: 13.6px;
    }
  }

  /* Narrow containers (width < 400px) */
  @container (max-width: 400px) {
    .brand-logo img {
      height: 24px;
    }

    .brand-title {
      font-size: 12px;
    }
  }

  /* Wide containers (aspect ratio >= 3:1) */
  @container (min-aspect-ratio: 3/1) {
    .brand-header {
      position: absolute;
      top: 12px;
      right: 24px;
      gap: 4px;
      z-index: 10;
    }

    .brand-logo img {
      height: 18px;
    }

    .brand-title {
      font-size: 10px;
    }
  }
</style>
